import * as React from 'react';
import classNames from 'classnames';
import {Text} from '..';
import style from './badge.scss';

export type BadgeType = 'primary' | 'lightPrimary' | 'darkGrey' | 'grey' | 'secondary' | 'red' | 'lightGrey' | 'yellow';

export interface BadgeProps {
  type?: BadgeType;
  text: string;
  className?: string;
}

export function Badge({
  type = 'primary',
  text = '',
  className,
} : BadgeProps) {
  return (
    <span className={classNames(className, style.badge, style[type])}>
      <Text
        type="badge"
        text={text}
        style={{marginBottom: 0}}
        inheritColor
      />
    </span>
  );
}

export default Badge;
